import { ca } from '@cian/analytics';

export function trackBannerShow(): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Listing',
    label: 'banner_onetwotrip',
  });
}

export function trackBannerClick(): void {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'Listing',
    label: 'banner_onetwotrip',
  });
}
